/**
 * This contains the map for vuex store mutation names
 */

export const initiativeMutation = {
  SET_DISPLAY_INITIATIVE_FIELDS: 'SET_DISPLAY_INITIATIVE_FIELDS'
}

export const notificationMutation = {
  SET_NOTIFICATIONS_LIST: 'SET_NOTIFICATIONS_LIST',
  MARK_NOTIFICATION_AS_READ: 'MARK_NOTIFICATION_AS_READ',
  SET_NOTIFICATIONS_SUMMARY: 'SET_NOTIFICATIONS_SUMMARY'
}

export const projectMutation = {
  SET_TEAM_PROJECTS: 'SET_TEAM_PROJECTS',
  UPDATE_PROJECT: 'UPDATE_PROJECT',
  ADD_PROJECT: 'ADD_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  SET_SECTIONS: 'SET_SECTIONS',
  UPDATE_SECTION: 'SET_SECTION'
}
